'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


/**
 * ANALYTICS WEB CLIENT EVENTS
 */
var UI_EVENT_TYPE = exports.UI_EVENT_TYPE = 'UI';
var TRACK_EVENT_TYPE = exports.TRACK_EVENT_TYPE = 'TRACK';
var SCREEN_EVENT_TYPE = exports.SCREEN_EVENT_TYPE = 'SCREEN';
var OPERATIONAL_EVENT_TYPE = exports.OPERATIONAL_EVENT_TYPE = 'OPERATIONAL';

/**
 * END ANALYTICS WEB CLIENT EVENTS
 */

var PAGE_EVENT_ACTION = exports.PAGE_EVENT_ACTION = 'page-view';

var SCREEN = exports.SCREEN = 'Screen';
var DRAWER = exports.DRAWER = 'Drawer';
var MODAL = exports.MODAL = 'Modal';
var INLINE_DIALOG = exports.INLINE_DIALOG = 'InlineDialog';
var DROPDOWN = exports.DROPDOWN = 'Dropdown';

var ScreenTypes = exports.ScreenTypes = {
    SCREEN: SCREEN,
    MODAL: MODAL,
    DRAWER: DRAWER,
    INLINE_DIALOG: INLINE_DIALOG,
    DROPDOWN: DROPDOWN
};

var EventTypes = exports.EventTypes = {
    UI: UI_EVENT_TYPE,
    TRACK: TRACK_EVENT_TYPE,
    SCREEN: SCREEN_EVENT_TYPE,
    OPERATIONAL: OPERATIONAL_EVENT_TYPE
};